import { createFileRoute } from "@tanstack/react-router";
import { DestinationsPage, buildDestinationsSchemas } from "@/components/DestinationsPage";
import { buildHead } from "@/content/seo";

const PATH = "/pt/destinos";
const URL = "https://vilamouradreamscruises.com" + PATH;
const TITLE = "Destinos do Algarve — 40+ Lugares Navegados | Vilamoura Dreams Cruises";
const DESC =
  "Guia completo de mais de 40 destinos do Algarve alcançados em iate privado a partir da Marina de Vilamoura — Benagil, Ponta da Piedade, Ria Formosa, Silves, Cacela Velha — com distâncias e notas de desembarque.";

export const Route = createFileRoute("/pt/destinos")({
  component: () => <DestinationsPage lang="pt" />,
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "destinos algarve iate, gruta de benagil, ponta da piedade, cruzeiro ria formosa, silves rio arade, cacela velha, charter privado vilamoura",
      altPath: { en: "/destinations", pt: PATH },
      extraScripts: buildDestinationsSchemas("pt", URL).map((s) => ({
        type: "application/ld+json",
        children: JSON.stringify(s),
      })),
    }),
});